import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';
import { AppData } from 'src/app/app.data';
import { CustomerDetails } from 'src/app/core/models/customer-details';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import { TreatmentModel } from 'src/app/core/models/treatment-model';
import { VisitReason } from 'src/app/core/interfaces/visit-reason';
import { VisitReasonModel } from 'src/app/core/models/visit-reason-model';
import { SchedulerService } from '../scheduler.service';
import { ApiResponseCode } from 'src/app/core/enums';
import { TreatmentService } from '../../treatments/treatment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-appointment-saved-msg',
  templateUrl: './appointment-saved-msg.component.html',
  styleUrls: ['./appointment-saved-msg.component.scss']
})
export class AppointmentSavedMsgComponent implements OnInit, AfterViewInit, OnDestroy {

  settings: Settings;
  error: string = '';
  patientName: string = '';
  schedulerName: string = '';
  practiceName: string = '';
  startDate: moment.Moment = moment();
  startTime: string;
  businessName: string = '';
  address: string = '';
  cityName: string = '';
  fullBranchAddress: string = ''
  reasons: VisitReason[] = [];


  eventID:number;

  constructor(
    private appSettings: AppSettings,
    private router: Router,
    private route: ActivatedRoute,
    private findTimeService: FindTimeService,
    private schedulerService:SchedulerService,
    private translate: TranslateService,
    private appData: AppData) {

    this.settings = appSettings.settings;
  }

  ngOnInit() {
    const eventID = +this.route.snapshot.paramMap.get('eventID'); // the (+) sign convert string to number
    if (eventID > 0) {
      this.loadData(eventID);
    }
  }

  loadData(eventID){
    this.schedulerService.getSuccessMessageData(eventID).subscribe(result => {
      
      if (result.Code === ApiResponseCode.Success) {
        const model = result.Data;
        this.patientName = model.CustomerName || '';
        this.schedulerName = model.SchedulerName || '';
        this.fullBranchAddress = model.BranchName || '';
        this.startDate = moment(model.StartAt);
        this.startTime = moment(model.StartAt).format('HH:mm');    
        this.reasons = model.VisitReasons.map(item => new VisitReasonModel(item));
      
      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }
  
  

  ngAfterViewInit() {    
    this.settings.loadingSpinner = false;
  }

  ngOnDestroy() {
    // clear data to prevent from user crate another appointment with the same treatment
    this.appData.formStateFindTime = null;
    this.appData.treatments = null;
    this.appData.priceListCodes = null;
    this.appData.customerDetails = null;
    this.appData.appointment = null;
    this.appData.visitItem = null;
    this.appData.bookVisitItem = null;
    this.appData.bookAppointment = null;
  }


  onNewAppointment() {
    this.router.navigate(['/find-time']);
  }

  onBack() {
    this.router.navigate(['/scheduler']);
  }

}


